import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

import { observable, flow, action } from "mobx";
import { PluginUpdate } from "../models";
import { request } from "../utils";
import { locationRestPluginUpdateGet } from "../wp-api";
let PluginUpdateStore = (_class = class PluginUpdateStore {
  constructor(rootStore) {
    _initializerDefineProperty(this, "busy", _descriptor, this);

    _initializerDefineProperty(this, "modalPlugin", _descriptor2, this);

    _initializerDefineProperty(this, "pluginUpdates", _descriptor3, this);

    _initializerDefineProperty(this, "pluginUpdateFetchErrors", _descriptor4, this);

    this.rootStore = void 0;
    this.showInModal = flow(function* (slug) {
      this.modalPlugin = slug;

      try {
        yield this.fetchPluginUpdate(slug);
      } catch (e) {
        console.log(e);
        throw e;
      }
    });
    this.fetchPluginUpdate = flow(function* (slug) {
      this.busy = true;

      try {
        const result = yield request({
          location: locationRestPluginUpdateGet,
          params: {
            slug
          }
        });
        const pluginUpdate = new PluginUpdate(result, this);
        this.pluginUpdates.set(slug, pluginUpdate);
        this.pluginUpdateFetchErrors.delete(slug);
        return pluginUpdate;
      } catch (e) {
        console.log(e);
        this.pluginUpdateFetchErrors.set(slug, e);
        throw e;
      } finally {
        this.busy = false;
      }
    });
    this.rootStore = rootStore;
  }

  hideModal() {
    this.modalPlugin = undefined;
  } // eslint-disable-next-line @typescript-eslint/member-ordering


}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "modalPlugin", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pluginUpdates", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pluginUpdateFetchErrors", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "hideModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideModal"), _class.prototype)), _class);
export { PluginUpdateStore };